import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';
interface AuthState {
    user: string | null,
    token: string | null,
    rememberMe?: boolean,
}

const previousAccessToken = localStorage.getItem('accessToken')
    ? localStorage.getItem('accessToken')
    : null

const initialState: AuthState = {
    user: null,
    token: previousAccessToken,
    rememberMe: true,
}

const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        setCredentials: (state, action) => {
            const { user, token, rememberMe } = action.payload;
            state.user = user;
            state.token = token;
            state.rememberMe = rememberMe;

            state.rememberMe ? localStorage.setItem('accessToken', token) : sessionStorage.setItem('accessToken', token);
        },
        logOut: (state) => {
            state.user = null;
            state.token = null;
            localStorage.removeItem('accessToken');
            localStorage.removeItem('profileStatus');

            sessionStorage.removeItem('accessToken');
            sessionStorage.removeItem('profileStatus');
        },
    },
})

export const { setCredentials, logOut } = authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state: RootState): string | null => state.auth.user;
export const selectCurrentToken = (state: RootState): string | null => state.auth.token;
export const selectRememberMe = (state: RootState): boolean | undefined => state.auth.rememberMe;
